import type { AxiosResponse } from "axios";
import { HttpClientNormal } from "../entities/HttpClient";
import { HttpResponse, SearchResponse } from "../entities/AxiosMethod";
import { UserLoginInfo, UserSearchDto } from "../login-service/entities/UserLoginEntity";
import { baseUrlApiWithoutTenant } from "../../commons/RootURL";

export class UserService {
  private _httpClient: HttpClientNormal = new HttpClientNormal();
  private _url: string = `${baseUrlApiWithoutTenant}group-calendars`;

  getUserLoginInformation = async (): Promise<HttpResponse<UserLoginInfo>> => {
    const url = `${this._url}/login-info`;
    return this._httpClient
      .get(url)
      .then((response: AxiosResponse) => new HttpResponse<UserLoginInfo>(response, UserLoginInfo))
      .catch((err) => new HttpResponse<UserLoginInfo>(err?.response));
  };
  searchUser = async (
    query: string,
    pageSize: number,
    isResource: boolean = false
  ): Promise<SearchResponse<UserSearchDto>> => {
    const url = isResource ? `${this._url}/search/resource` : `${this._url}/search/user`;
    return this._httpClient
      .post(url, { keyword: query, pageSize: pageSize })
      .then(
        (response: AxiosResponse) =>
          new SearchResponse<UserSearchDto>(response, UserSearchDto, "users")
      )
      .catch((err) => new SearchResponse<UserSearchDto>(err?.response));
  };
}
